<template>
  <div class="live-coupon">
    <div class="status">
      <div>本场直播优惠券</div>
      <div class="status-txt">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYBAMAAADjUntGAAAAG1BMVEVHcEwmwU4nwk4qv1Amw00nwkwmwU4mwU4nwk5FzY+hAAAACHRSTlMAgOUwV4/PzlRUxXQAAABFSURBVBjTYzBrZUAAjQ4HBKejQwALB6QezgGph3NADBI4zBkBCA5TRwuCw9HROFg4GUAPsoHcVgFkGKkyMDArAV0NZAAAtbE/IJIiN5EAAAAASUVORK5CYII="
        />
        已开播
      </div>
    </div>
    <el-tabs>
      <el-tab-pane label="店铺券">
        <DP />
      </el-tab-pane>
      <el-tab-pane label="平台券"></el-tab-pane>
      <el-tab-pane label="主播券"></el-tab-pane>
      <el-tab-pane label="支付券">
        <template slot="label">
          <span>支付券</span>
          <svg>
            <use href="#icon-yiwen" />
          </svg>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DP from "./dianpu.vue";
export default {
  components: {
    DP,
  },
};
</script>
<style lang="less" scoped>
.live-coupon {
  background-color: #fff;
  min-height: 300px;
  padding: 24px;

  svg {
    fill: currentColor;
    height: 1em;
    overflow: hidden;
    vertical-align: -0.15em;
    width: 1em;
  }

  .status {
    align-items: center;
    color: #12141a;
    display: flex;
    font-size: 18px;
    font-weight: 500;
    height: 26px;
    line-height: 26px;
    margin-bottom: 12px;
    .status-txt {
      align-items: center;
      background-color: rgba(39, 194, 78, 0.1);
      border-radius: 2px;
      color: #27c24e;
      display: flex;
      font-size: 14px;
      font-weight: 500;
      height: 24px;
      margin-left: 8px;
      padding: 0 8px;
      img {
        height: 12px;
        margin-right: 4px;
        width: 12px;
      }
    }
  }

  &::v-deep  .el-tabs {
    position: relative;
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      color: #515361;
      //   margin: 0 16px;
      padding: 24px 16px 16px 16px;
      height: auto;
      line-height: normal;
      &:nth-child(2) {
        padding-left: 0;
      }

      &.is-active {
        color: #6557fa;
        font-weight: bold;
        outline: none;
      }
      &:hover {
        color: #7570fb;
      }
    }

    .el-tabs__active-bar {
      height: 3px;
      background-color: #6557fa;
    }
    .el-tabs__nav-wrap::after {
      border-bottom: 1px solid #ebecf2;
      background: none;
    }

    .el-tabs__content {
      position: static;
    }
  }
}
</style>